const ContactDetails = (props) => {
  return (
    <>
      <div>{props.email}</div>
      <div>{props.phoneNumber}</div>
    </>
  );
};
export default ContactDetails;
